import * as React from 'react';
import * as PropTypes from 'prop-types';
import Tooltip from 'components/Tooltip';
import classNames from 'classnames';
import { ReactTableDefaults } from 'react-table';
import { ReactComponent as SortIcon } from 'images/ic-arrow-downward.svg';

export function ChecksThComponent({ style, className, toggleSort, tooltip, children }) {
  ChecksThComponent.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    toggleSort: PropTypes.func,
    tooltip: PropTypes.bool,
    children: PropTypes.node,
  };
  return (
    <ReactTableDefaults.ThComponent
      className={classNames(className, 'ChecksTable__th')}
      style={style}
      onClick={toggleSort}
    >
      <SortIcon
        className={'ChecksTable__sort-action'}
        width={'24px'}
        height={'24px'}
        fill={'#263238'}
      />
      {children}
      {tooltip && <Tooltip content={tooltip} fixed={true} isFormClass={false} hasWrapper={false} />}
    </ReactTableDefaults.ThComponent>
  );
}
